import styled from "styled-components";

export const ContainerGraphics = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  flex: 1;
`;
